<template>
    <form ref="main">
        <div class="row">
            <div class="col-lg-12">
                <div class="checkout__title">
                    <h2 class="def-title-3">{{jsNotChangeData.messages.orderTitle}}</h2>
                </div>
                <div v-if="warning" style="color: #828200">{{warning}}</div>
                <div v-if="error" style="color: #FF0000">
                    <div v-for="errorGroup in error">
                        <div v-for="mess in errorGroup">{{mess}}</div>
                    </div>
                </div>
<!--                <div v-if="component.hidden">-->
<!--                    <input v-for="inp in component.hidden" type="hidden" :name="inp.name" :value="inp.value">-->
<!--                </div>-->
            </div>
        </div>
        <div class="checkout">
            <div>
                <checkout-step :activeStep="activeStep" :step="1" ref="checkout-step-1">
                    <template v-slot:header>
                        <h5 class="def-title-5" >{{properties('sale.order.ajax').title}}</h5>
<!--                        <div v-if="activeStep" class="checkout__edit-step">-->
<!--                            {{jsNotChangeData.messages.edit}}-->
<!--                        </div>-->
                    </template>
                    <div class="checkout__inner-block">
                        <fieldset>
                            <checkout-user-properties :result="properties('sale.order.ajax')" />
                        </fieldset>
                    </div>
                </checkout-step>
                <checkout-step :activeStep="activeStep" :step="2" ref="checkout-step-2">
                    <template v-slot:header>
                        <h5 class="def-title-5" >{{delivery('sale.order.ajax').title}}</h5>
<!--                        <div v-if="activeStep"  class="checkout__edit-step">-->
<!--                            {{jsNotChangeData.messages.edit}}-->
<!--                        </div>-->
                    </template>
                    <div class="checkout__inner-block">
                        <checkout-delivery
                            :result="delivery('sale.order.ajax')"
                            @setAjax="setAjax"
                        />
                    </div>
                </checkout-step>
                <checkout-step :activeStep="activeStep" :step="3" ref="checkout-step-3">
                    <template v-slot:header>
                        <h5 class="def-title-5" >{{payment('sale.order.ajax').title}}</h5>
<!--                        <div v-if="activeStep"  class="checkout__edit-step">-->
<!--                            {{jsNotChangeData.messages.edit}}-->
<!--                        </div>-->
                    </template>
                    <div class="checkout__inner-block">
                        <checkout-pay-systems :result="payment('sale.order.ajax')" @setAjax="setAjax" />
                    </div>
                </checkout-step>
                <checkout-step :activeStep="activeStep" :step="4" ref="checkout-step-4">
                    <template v-slot:header>
                        <h5 class="def-title-5" >{{ jsNotChangeData.messages.confirmTitle }}</h5>
                    </template>
                    <div class="checkout__inner-block">
                        <checkout-confirmation :result="dataConfirmation" />
                        <input name="ORDER_DESCRIPTION" :placeholder="jsNotChangeData.messages.addPromo" type="text" class="def-input order-description"><br>
                        <button class="def-button button-confirm" type="button" :name="component.ACTION_VARIABLE"
                                value="saveOrderAjax" @click="saveOrder">{{ jsNotChangeData.messages.confirmButton }}</button>
                    </div>
                </checkout-step>
                <div v-if="warning && warning.PAY_SYSTEM" style="color: #828200">
                    <span v-for="mess in warning.PAY_SYSTEM">{{mess}}</span>
                </div>
                <input type="hidden" :name="component.ACTION_VARIABLE" value="refreshOrderAjax">
            </div>
            <div>
                <checkout-information
                    :result="jsNotChangeData"
                    :jsData="jsData"
                    :total="total"
                    @setAjax="setAjax"
                />
            </div>
        </div>
    </form>
</template>

<script>
import {component, result} from './MOCKED_DATA.js';

export default {
    selector: '.sale-order-ajax',
    name: 'sale-order-ajax',
    props: {
        result: {
            type: Object,
            default: () => result
        },
        component: {
            type: Object,
            default: () => component
        }
    },
    data: function () {
        return {
            jsData: this.result,
            jsNotChangeData: {
                ...this.component,
                // Преобразование данных для компонента "order-total"
                // Временное решение нужно будет проверить как гуляют данные после аякса и использовать в нужном виде
                price: this.getFormatTotal(this.result.TOTAL),
            },
            activeStep: true,
            total : {
                ...this.component,
                // Преобразование данных для компонента "order-total"
                // Временное решение нужно будет проверить как гуляют данные после аякса и использовать в нужном виде
                price: this.getFormatTotal(this.result.TOTAL),
            },
        };
    },
    methods: {
        updateData(result) {
            if (typeof result == "string") {
                this.jsData.ERROR = {errorGroup: [result]};
            } else if (!App.empty(result.error) && result.error !== false) {
                this.jsData.ERROR = {errorGroup: [result.error]};
                if (App.debug) {
                    console.log('Ответ с ошибкой', result);
                }
            } else if (!App.empty(result.order.ERROR)) {
                this.jsData.ERROR = result.order.ERROR;
                if (App.debug) {
                    console.log('Ответ с ошибкой', result);
                }
            } else if (result.order && result.order.ID && result.order.REDIRECT_URL) {
                location = result.order.REDIRECT_URL;
                if (App.debug) {
                    console.log('Ответ для переадресации', result);
                }
            } else if (result.order) {
                this.jsData = result.order;
                if(result.order.items) {
                    this.jsNotChangeData.items = result.order.items;
                }
                this.jsNotChangeData.price = this.getFormatTotal(this.jsData.TOTAL);
                //console.log(this.jsData.TOTAL);
                //console.log(this.jsNotChangeData);

                this.total = this.jsNotChangeData;
                if(!this.total.price) {
                    this.total.price = {};
                };
                //console.log(result.order);

                this.total.price.printDeliveryPrice = result.order.TOTAL.DELIVERY_PRICE_FORMATED;


                if (App.debug) {

                    console.log('Корретный ответ', result);

                }
            } else if (this.debug) {
                if (App.debug) {
                    console.log('Попали в ситуацию когда не корректный ответ сервера, нужно проверить: ', result);
                }
            }
        },
        /**
         * @todo:js В этом методе нужно использовать ajax встроенный если есть, если нет то axios
         * @todo:js Вычистить из метода обращения через jQuery
         */
        setAjax() {
            let ajaxUrl = this.component.ajaxUrl;
            let formData = {order: BX.ajax.prepareForm(this.$refs.main).data};
            // let formData = BX.ajax.prepareForm(this.$refs.main).data;
            // console.log(formData, '<-----');
            if (this.component.hidden) {
                this.component.hidden.forEach(function(item, i, arr) {
                    formData[item.name] = item.value;
                });
            }
            formData[this.component.ACTION_VARIABLE] = 'refreshOrderAjax';
            if(formData.order.COUPON == undefined) {
                formData.order.DEL_COUPON = true;
            }
            $.ajax({type: "POST", url: ajaxUrl, dataType: 'json', data: formData, success: this.updateData});
        },
        saveOrder() {
            let ajaxUrl = this.component.ajaxUrl;
            let formData = BX.ajax.prepareForm(this.$refs.main).data;

            if (this.component.hidden) {
                this.component.hidden.forEach(function(item, i, arr) {
                    formData[item.name] = item.value;
                });
            }
            formData[this.component.ACTION_VARIABLE] = 'saveOrderAjax';
            // this.handlerClickGoogle();
            $.ajax({type: "POST", url: ajaxUrl, data: formData, success: this.updateData});
        },

        handlerClickGoogle() {
            try {
                const product = this.component.dataLayer.data;

                dataLayer.push({
                    'ecommerce': {
                        'currencyCode': this.component.dataLayer.currencyCode,
                        'checkout': {
                            'products': product
                        }
                    },
                    'event': 'gtmUaEvent',
                    'gtmUaEventCategory': 'Enhanced Ecommerce',
                    'gtmUaEventAction': 'Checkout Step 1',
                    'gtmUaEventNonInteraction': 'False'
                });
            } catch (err) {
                console.error(err);
            }
        },
        // changeStep(step) {
        //     if (!this.validateForm() && this.activeStep < step) {
        //
        //
        //
        //         return;
        //     }
        //     this.activeStep = step;
        // },
        filterProperties(arr) {
            try {
                if (Array.isArray(arr)) {
                    return arr.map(el => ({
                        title: el.NAME,
                        value: Array.isArray(el.VALUE) && el.VALUE[0] !== undefined ? el.VALUE[0] : ''
                    }))
                } else {
                    return Object.values(arr).map(el => ({
                        title: el.NAME,
                        value: Array.isArray(el.VALUE) && el.VALUE[0] !== undefined ? el.VALUE[0] : ''
                    }))
                }

            } catch (err) {
                console.error(err);
            }
        },
        delivery(type) {
            if (type === 'sale.order.ajax') {

                return {
                    title: this.messages.deliveryName,
                    deliveries: this.jsData.DELIVERY,
                    messages: this.messages,
                    properties: this.jsData.ORDER_PROP.properties,
                    STORE_LIST: this.jsData.STORE_LIST,
                    BUYER_STORE: this.jsData.BUYER_STORE,
                    deliveryRouts: this.jsNotChangeData?.DELIVERY,
                }
            } else if (type == 'checkoutSuccess') {
                let items = [];


                for (let delivery in this.jsData.DELIVERY) {
                    let el = this.jsData.DELIVERY[delivery];
                    if (el.CHECKED == 'Y') {
                        items.push({title: this.messages.deliveryName, value: el.NAME});
                    }
                }
                // доставка
                if (this.jsNotChangeData.price.printDeliveryPrice&&false) {
                    items.push({
                        title: this.jsNotChangeData.messages.totalDeliveryPrice,
                        value: this.jsNotChangeData.price.printDeliveryPrice,
                        sale: false,
                    });
                };
                return items;
            }
        },
        properties(type) {
            if (type === 'sale.order.ajax') {
                return  {
                    //TODO: title добавить в messages
                    title: this.jsNotChangeData.messages.customer,
                    properties: this.jsData.ORDER_PROP.properties,
                    userInfo: this.jsNotChangeData.userInfo,
                    userConfirmData: this.jsNotChangeData.userConfirmData,
                    messages: this.jsNotChangeData.messages,
                }
            } else {
                return  this.filterProperties(this.jsData.ORDER_PROP.properties);
            }
        },
        payment(type) {
            if (type === 'sale.order.ajax') {
                return {
                    //TODO: title добавить в messages
                    title: this.messages.paySystemName,
                    paySystems: this.jsData.PAY_SYSTEM,
                    messages: this.messages,
                }
            } else if (type == 'checkoutSuccess') {
                for (let paySystem in this.jsData.PAY_SYSTEM) {
                    let el = this.jsData.PAY_SYSTEM[paySystem];
                    if (el.CHECKED == 'Y') {
                        return [
                            {
                                'title': this.messages.paySystemName,
                                'value': el.NAME
                            }
                        ];
                    }
                }
            }
        },
        getPriceInfo() {
            let items = [];

            // Общая цена
            if (this.jsNotChangeData.price.printPriceOld) {
                items.push({
                    title: this.messages.totalPrice,
                    value: this.jsNotChangeData.price.printPriceOld,
                });
            }

            // Скидка
            if (this.jsNotChangeData.price.printDiscount) {
                items.push({
                    title: this.messages.discountPrice,
                    value: this.jsNotChangeData.price.printDiscount,
                    sale: true,
                });
            };

            // доставка
          /*  if (this.jsNotChangeData.price.printDiscount||true) {
                items.push({
                    title: "test",
                    value: "0",
                    sale: false,
                });
            };*/

            // Цена
            if (this.jsNotChangeData.price.printPrice) {
                items.push({
                    title: this.messages.price,
                    value: this.jsNotChangeData.price.printPrice,
                });
            }

            return items;
        },
        validateForm() {
            const requiredStep = this.$refs[`checkout-step-${this.activeStep}`].$el;
            const inputRequired = requiredStep.querySelectorAll('input[required]');
            let isValid = true;
            let scrolTo = false;
            inputRequired.forEach(el => {
                if (!el.checkValidity()) {
                    if(!scrolTo) {
                        scrolTo = el;
                    }
                    isValid = false;
                }
            });

            if(scrolTo) {
                let h = $(window).height()/2;
                let destination = $(scrolTo).offset().top-h;
                $("html:not(:animated),body:not(:animated)").animate({scrollTop: destination}, 800);

            }

            return isValid;
        },
        getFormatTotal(total) {
            console.log(total);
            return {
                printDeliveryPrice: total.DELIVERY_PRICE_FORMATED,
                printPrice: total.ORDER_TOTAL_PRICE_FORMATED,
                printDiscount: total.DISCOUNT_PRICE_FORMATED,
                printPriceOld: total.PRICE_WITHOUT_DISCOUNT,
            };
        }
    },
    computed: {
        messages() {
            return this.jsNotChangeData.messages;
        },
        warning: function () {
            if (!App.empty(this.jsData.WARNING)) {
                return this.jsData.WARNING;
            }
        },
        error: function () {
            if (!App.empty(this.jsData.ERROR)) {
                return this.jsData.ERROR;
            }
        },
        dataConfirmation() {
            return {
                items: [
                    this.properties('checkoutSuccess'),
                    this.payment('checkoutSuccess'),
                    this.delivery('checkoutSuccess'),
                    this.getPriceInfo(),
                ]
            }
        },
    },
    mounted: function () {
        if (App.debug) {
            console.log('Component: sale-order-ajax', this.result, this.jsNotChangeData);
        }
    }
}
</script>

<style lang="scss" scoped>
    .sale-order-ajax{
        margin-bottom: 56px;
        @include point-md{
            margin-bottom: 80px;
        }
        .order-description{
            width: 100%;
            @include point-md {
                max-width: 356px;
            }
            @include point-lg {
                max-width: 400px;
            }
        }
    }
    .checkout{
        display: grid;
        grid-template-columns: 1fr;
        @include point-lg{
            grid-template-columns: 67% 33%;
            grid-column-gap: 4px;
        }
        &__edit-step{
            margin-left: auto;
            font-size: rem(10);
            text-decoration: underline;
            text-decoration-style: dashed;
            text-underline-position: under;
            @include point-md{
                font-size: rem(12);
            }
            &:hover{
                cursor: pointer;
            }
        }
        //&__inner-block{
        //    padding: 0 16px 16px 16px;
        //    @include point-md{
        //        padding: 0 24px 24px 80px;
        //    }
        //}
        .def-input{
            margin-bottom: 8px;
            color: #757575;
            @include point-md{
                height: 56px;
            }
        }
        .def-radio{
            & + * {
                margin-bottom: 16px;
                font-weight: 500;
                font-size: rem(14);
                line-height: 110%;
                color: var(--text-colour-primary);
                @include point-md{
                    font-size: rem(16);
                }
            }
        }
        .def-button{
            text-transform: uppercase;
            font-size: rem(14);
            letter-spacing: 0.08em;
            padding: 0 48px;
        }
        .button-confirm{
            padding: 0 10px;
            width: 100%;
            margin-top: 16px;
            @include point-md{
                padding: 0 48px;
                width: auto;
            }
        }
    }
</style>